// @ts-check
import { createDataGridContext } from '~/components/Shared/ZeroDataGrid/ZeroDataGrid.context';
import { useContext } from "react";

const [IncidentTemplateDataGridContext, IncidentTemplateDataGridContextProvider] = createDataGridContext('incident-templates');
export { IncidentTemplateDataGridContext, IncidentTemplateDataGridContextProvider };

/** @returns {BaseDataGridContextValue} */
export function useIncidentTemplateDataGridContext() {
    return useContext(IncidentTemplateDataGridContext);
} 